// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { BidContractOverview_RevisionFragmentDoc } from '../../../components/bid-contracts/BidContractOverview.generated';
import { PandaDocButtonDataFragmentDoc } from '../../components/PandaDocUploadButton.generated';
import { DocumentEditorDetailFragmentDoc } from '../../../fragments/circularFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidContractQueryVariables = Types.Exact<{
  bidContractId: Types.Scalars['ID']['input'];
}>;


export type BidContractQuery = { __typename?: 'Query', bidContract: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, isInternalEstimate: boolean, isPrimary?: boolean | null | undefined, revisions: Array<{ __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } } };

export type SaveBidContractMutationVariables = Types.Exact<{
  input: Types.SaveBidContractInput;
}>;


export type SaveBidContractMutation = { __typename?: 'Mutation', saveBidContract: { __typename?: 'SaveBidContractResult', bidContract: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, isInternalEstimate: boolean, isPrimary?: boolean | null | undefined, revisions: Array<{ __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } } } };

export type BidContractRevisionQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
}>;


export type BidContractRevisionQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, hasOutdatedScope: boolean, signedOn?: Types.Scalars['Date']['input'] | null | undefined, internalNote?: string | null | undefined, hasAwardedBidPackageVersion: boolean, bidContract: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, isInternalEstimate: boolean, isPrimary?: boolean | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined, internalEstimateBidPackage?: { __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } | null | undefined, revisions: Array<{ __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } }, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, externalError?: string | null | undefined, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, parent:
          | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
              > }> | null | undefined }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
        , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', number: string, id: string, name: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, ofIti: boolean, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string, name: string } | null | undefined, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, parent: { __typename?: 'ProjectCustomOption', id: string, displayName: string } }
        | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, parent:
            | { __typename?: 'ReadyPlan', id: string, displayName: string }
            | { __typename?: 'PlanPackage', id: string, displayName: string }
            | { __typename?: 'DesignPackage', id: string, displayName: string }
            | { __typename?: 'ProductOffering', id: string, displayName: string }
           }
        | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, parent:
            | { __typename?: 'ReadyPlan', id: string, displayName: string }
            | { __typename?: 'PlanPackage', id: string, displayName: string }
            | { __typename?: 'DesignPackage', id: string, displayName: string }
            | { __typename?: 'ProductOffering', id: string, displayName: string }
           }
       | null | undefined }>, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, parent:
        | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }> | null | undefined }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
      , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, canComplete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, bidPackage: { __typename?: 'BidPackage', id: string, isPlanBasedV2: boolean } } | null | undefined, planBasedLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, productOffering: { __typename?: 'ProductOffering', id: string, name: string } } } }> } };

export type SaveBidContractRevisionMutationVariables = Types.Exact<{
  input: Types.SaveBidContractRevisionInput;
}>;


export type SaveBidContractRevisionMutation = { __typename?: 'Mutation', saveBidContractRevision: { __typename?: 'SaveBidContractRevisionResult', bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, hasOutdatedScope: boolean, signedOn?: Types.Scalars['Date']['input'] | null | undefined, internalNote?: string | null | undefined, hasAwardedBidPackageVersion: boolean, bidContract: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, isInternalEstimate: boolean, isPrimary?: boolean | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined, internalEstimateBidPackage?: { __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } | null | undefined, revisions: Array<{ __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } }, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, externalError?: string | null | undefined, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, parent:
            | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                  | { __typename?: 'StandaloneProject', id: string, name: string }
                  | { __typename?: 'Region', id: string, name: string }
                  | { __typename?: 'Market', id: string, name: string }
                  | { __typename?: 'Community', id: string, name: string }
                  | { __typename?: 'Subdivision', id: string, name: string }
                  | { __typename?: 'Lot', id: string, name: string }
                  | { __typename?: 'Structure', id: string, name: string }
                  | { __typename?: 'Unit', id: string, name: string }
                > }> | null | undefined }
            | { __typename?: 'PlanPackage', id: string }
            | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
            | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Region', id: string, name: string, parent?:
                    | { __typename?: 'StandaloneProject', id: string }
                    | { __typename?: 'Region', id: string }
                    | { __typename?: 'Market', id: string }
                    | { __typename?: 'Community', id: string }
                    | { __typename?: 'Subdivision', id: string }
                    | { __typename?: 'Lot', id: string }
                    | { __typename?: 'Structure', id: string }
                    | { __typename?: 'Unit', id: string }
                   | null | undefined }
                | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
                | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
                | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
                | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
                | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
                | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
              > }
          , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', number: string, id: string, name: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, ofIti: boolean, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string, name: string } | null | undefined, itemTemplateItem?:
          | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
          | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
          | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, parent: { __typename?: 'ProjectCustomOption', id: string, displayName: string } }
          | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, parent:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             }
          | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, parent:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             }
         | null | undefined }>, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, parent:
          | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
              > }> | null | undefined }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
        , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, canComplete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, bidPackage: { __typename?: 'BidPackage', id: string, isPlanBasedV2: boolean } } | null | undefined, planBasedLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, productOffering: { __typename?: 'ProductOffering', id: string, name: string } } } }> } } };

export type InternallySignBidContractRevisionMutationVariables = Types.Exact<{
  input: Types.InternallySignBidContractRevisionInput;
}>;


export type InternallySignBidContractRevisionMutation = { __typename?: 'Mutation', internallySignBidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, hasOutdatedScope: boolean, signedOn?: Types.Scalars['Date']['input'] | null | undefined, internalNote?: string | null | undefined, hasAwardedBidPackageVersion: boolean, bidContract: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, isInternalEstimate: boolean, isPrimary?: boolean | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined, internalEstimateBidPackage?: { __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } | null | undefined, revisions: Array<{ __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } }, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, externalError?: string | null | undefined, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, parent:
          | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
              > }> | null | undefined }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
          | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Region', id: string, name: string, parent?:
                  | { __typename?: 'StandaloneProject', id: string }
                  | { __typename?: 'Region', id: string }
                  | { __typename?: 'Market', id: string }
                  | { __typename?: 'Community', id: string }
                  | { __typename?: 'Subdivision', id: string }
                  | { __typename?: 'Lot', id: string }
                  | { __typename?: 'Structure', id: string }
                  | { __typename?: 'Unit', id: string }
                 | null | undefined }
              | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
              | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
              | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
              | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
              | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
              | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
            > }
        , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', number: string, id: string, name: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, ofIti: boolean, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string, name: string } | null | undefined, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, parent: { __typename?: 'ProjectCustomOption', id: string, displayName: string } }
        | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, parent:
            | { __typename?: 'ReadyPlan', id: string, displayName: string }
            | { __typename?: 'PlanPackage', id: string, displayName: string }
            | { __typename?: 'DesignPackage', id: string, displayName: string }
            | { __typename?: 'ProductOffering', id: string, displayName: string }
           }
        | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, parent:
            | { __typename?: 'ReadyPlan', id: string, displayName: string }
            | { __typename?: 'PlanPackage', id: string, displayName: string }
            | { __typename?: 'DesignPackage', id: string, displayName: string }
            | { __typename?: 'ProductOffering', id: string, displayName: string }
           }
       | null | undefined }>, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, parent:
        | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }> | null | undefined }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
      , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, canComplete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, bidPackage: { __typename?: 'BidPackage', id: string, isPlanBasedV2: boolean } } | null | undefined, planBasedLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, productOffering: { __typename?: 'ProductOffering', id: string, name: string } } } }> } };

export type DevelopmentContractBidContractFragment = { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, isInternalEstimate: boolean, isPrimary?: boolean | null | undefined, revisions: Array<{ __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } };

export type BidContractRevisionFragment = { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, hasOutdatedScope: boolean, signedOn?: Types.Scalars['Date']['input'] | null | undefined, internalNote?: string | null | undefined, hasAwardedBidPackageVersion: boolean, bidContract: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, isInternalEstimate: boolean, isPrimary?: boolean | null | undefined, bidRequest?: { __typename?: 'BidPackageRequest', id: string, bidPackage: { __typename?: 'BidPackage', id: string, name: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } } | null | undefined, internalEstimateBidPackage?: { __typename?: 'BidPackage', id: string, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } | null | undefined, revisions: Array<{ __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, type: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } }, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, canCreatePandaDoc: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus, externalError?: string | null | undefined, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, parent:
        | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }> | null | undefined }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
      , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', number: string, id: string, name: string }>, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, ofIti: boolean, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string, name: string } | null | undefined, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
      | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
      | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, parent: { __typename?: 'ProjectCustomOption', id: string, displayName: string } }
      | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, parent:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         }
      | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, parent:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         }
     | null | undefined }>, document?: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, parent:
      | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }> | null | undefined }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
    , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, canComplete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, bidPackage: { __typename?: 'BidPackage', id: string, isPlanBasedV2: boolean } } | null | undefined, planBasedLineItems: Array<{ __typename?: 'PlanBasedBidContractLineItem', id: string, totalCostInCents: number, groupLine: { __typename?: 'BidPlanChildGroupLine', id: string, group: { __typename?: 'BidPlanChildGroup', id: string, productOffering: { __typename?: 'ProductOffering', id: string, name: string } } } }> };

export type BidContractLineItemFragment = { __typename?: 'BidContractLineItem', id: string, ofIti: boolean, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string, name: string } | null | undefined, itemTemplateItem?:
    | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
    | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
    | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, parent: { __typename?: 'ProjectCustomOption', id: string, displayName: string } }
    | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, parent:
        | { __typename?: 'ReadyPlan', id: string, displayName: string }
        | { __typename?: 'PlanPackage', id: string, displayName: string }
        | { __typename?: 'DesignPackage', id: string, displayName: string }
        | { __typename?: 'ProductOffering', id: string, displayName: string }
       }
    | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, parent:
        | { __typename?: 'ReadyPlan', id: string, displayName: string }
        | { __typename?: 'PlanPackage', id: string, displayName: string }
        | { __typename?: 'DesignPackage', id: string, displayName: string }
        | { __typename?: 'ProductOffering', id: string, displayName: string }
       }
   | null | undefined };

export type BidContractLineItemItemTemplateItem_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } };

export type BidContractLineItemItemTemplateItem_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } };

export type BidContractLineItemItemTemplateItem_ProjectCustomItem_Fragment = { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, parent: { __typename?: 'ProjectCustomOption', id: string, displayName: string } };

export type BidContractLineItemItemTemplateItem_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, parent:
    | { __typename?: 'ReadyPlan', id: string, displayName: string }
    | { __typename?: 'PlanPackage', id: string, displayName: string }
    | { __typename?: 'DesignPackage', id: string, displayName: string }
    | { __typename?: 'ProductOffering', id: string, displayName: string }
   };

export type BidContractLineItemItemTemplateItem_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, parent:
    | { __typename?: 'ReadyPlan', id: string, displayName: string }
    | { __typename?: 'PlanPackage', id: string, displayName: string }
    | { __typename?: 'DesignPackage', id: string, displayName: string }
    | { __typename?: 'ProductOffering', id: string, displayName: string }
   };

export type BidContractLineItemItemTemplateItemFragment =
  | BidContractLineItemItemTemplateItem_ItemTemplateItemVersion_Fragment
  | BidContractLineItemItemTemplateItem_ItemTemplateItem_Fragment
  | BidContractLineItemItemTemplateItem_ProjectCustomItem_Fragment
  | BidContractLineItemItemTemplateItem_TakeoffLineItem_Fragment
  | BidContractLineItemItemTemplateItem_TakeoffLineItemVersion_Fragment
;

export type DevContractHeader_ItemTemplateCostUpdateFragment = { __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } };

export type DeleteBidContractRevisionMutationVariables = Types.Exact<{
  input: Types.DeleteBidContractRevisionInput;
}>;


export type DeleteBidContractRevisionMutation = { __typename?: 'Mutation', deleteBidContractRevision: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export const DevContractHeader_ItemTemplateCostUpdateFragmentDoc = gql`
    fragment DevContractHeader_ItemTemplateCostUpdate on ItemTemplateCostUpdate {
  id
  itemTemplate {
    id
    displayName
  }
  completed
}
    `;
export const DevelopmentContractBidContractFragmentDoc = gql`
    fragment DevelopmentContractBidContract on BidContract {
  id
  archivedAt
  revisions {
    id
    version
    startDate
    itemTemplateCostUpdates {
      ...DevContractHeader_ItemTemplateCostUpdate
    }
  }
  developments {
    ...Named
  }
  projects {
    ...Named
  }
  tradePartner {
    id
    name
  }
  isInternalEstimate
  isPrimary
  bidRequest {
    id
    bidPackage {
      id
      name
      bidPackageGroup {
        id
      }
    }
  }
  type {
    code
  }
}
    ${DevContractHeader_ItemTemplateCostUpdateFragmentDoc}
${NamedFragmentDoc}`;
export const BidContractLineItemItemTemplateItemFragmentDoc = gql`
    fragment BidContractLineItemItemTemplateItem on BaseItemLike {
  id
  parent {
    id
    displayName
  }
  totalCostInCents
}
    `;
export const BidContractLineItemFragmentDoc = gql`
    fragment BidContractLineItem on BidContractLineItem {
  id
  ofIti
  totalCostInCents
  bidItem {
    ...Named
  }
  itemTemplateItem {
    id
    ...BidContractLineItemItemTemplateItem
  }
}
    ${NamedFragmentDoc}
${BidContractLineItemItemTemplateItemFragmentDoc}`;
export const BidContractRevisionFragmentDoc = gql`
    fragment BidContractRevision on BidContractRevision {
  id
  ...BidContractOverview_Revision
  bidContract {
    ...DevelopmentContractBidContract
    bidRequest {
      id
      bidPackage {
        id
        bidPackageGroup {
          id
        }
      }
    }
    internalEstimateBidPackage {
      id
      bidPackageGroup {
        id
      }
    }
  }
  version
  startDate
  endDate
  status {
    code
    name
  }
  canCreatePandaDoc {
    allowed
    disabledReasons {
      message
    }
  }
  canDelete {
    allowed
    disabledReasons {
      message
    }
  }
  pandaDoc {
    ...PandaDocButtonData
    document {
      ...DocumentEditorDetail
    }
  }
  costCodes {
    ...Named
    number
  }
  lineItems {
    ...BidContractLineItem
  }
  document {
    ...DocumentEditorDetail
  }
  hasOutdatedScope
  itemTemplateCostUpdates {
    ...DevContractHeader_ItemTemplateCostUpdate
  }
  signedOn
  internalNote
  hasAwardedBidPackageVersion
  bidPackageVersion {
    id
    canComplete {
      ...PotentialOperationDetails
    }
    bidPackage {
      id
      isPlanBasedV2
    }
  }
}
    ${BidContractOverview_RevisionFragmentDoc}
${DevelopmentContractBidContractFragmentDoc}
${PandaDocButtonDataFragmentDoc}
${DocumentEditorDetailFragmentDoc}
${NamedFragmentDoc}
${BidContractLineItemFragmentDoc}
${DevContractHeader_ItemTemplateCostUpdateFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const BidContractDocument = gql`
    query BidContract($bidContractId: ID!) {
  bidContract(id: $bidContractId) {
    ...DevelopmentContractBidContract
  }
}
    ${DevelopmentContractBidContractFragmentDoc}`;

/**
 * __useBidContractQuery__
 *
 * To run a query within a React component, call `useBidContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractQuery({
 *   variables: {
 *      bidContractId: // value for 'bidContractId'
 *   },
 * });
 */
export function useBidContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractQuery, BidContractQueryVariables> & ({ variables: BidContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractQuery, BidContractQueryVariables>(BidContractDocument, options);
      }
export function useBidContractLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractQuery, BidContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractQuery, BidContractQueryVariables>(BidContractDocument, options);
        }
// @ts-ignore
export function useBidContractSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractQuery, BidContractQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractQuery, BidContractQueryVariables>;
export function useBidContractSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractQuery, BidContractQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractQuery | undefined, BidContractQueryVariables>;
export function useBidContractSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractQuery, BidContractQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractQuery, BidContractQueryVariables>(BidContractDocument, options);
        }
export type BidContractQueryHookResult = ReturnType<typeof useBidContractQuery>;
export type BidContractLazyQueryHookResult = ReturnType<typeof useBidContractLazyQuery>;
export type BidContractSuspenseQueryHookResult = ReturnType<typeof useBidContractSuspenseQuery>;
export type BidContractQueryResult = ApolloReactCommon.QueryResult<BidContractQuery, BidContractQueryVariables>;
export const SaveBidContractDocument = gql`
    mutation SaveBidContract($input: SaveBidContractInput!) {
  saveBidContract(input: $input) {
    bidContract {
      ...DevelopmentContractBidContract
    }
  }
}
    ${DevelopmentContractBidContractFragmentDoc}`;

/**
 * __useSaveBidContractMutation__
 *
 * To run a mutation, you first call `useSaveBidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidContractMutation, { data, loading, error }] = useSaveBidContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBidContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidContractMutation, SaveBidContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidContractMutation, SaveBidContractMutationVariables>(SaveBidContractDocument, options);
      }
export type SaveBidContractMutationHookResult = ReturnType<typeof useSaveBidContractMutation>;
export type SaveBidContractMutationResult = ApolloReactCommon.MutationResult<SaveBidContractMutation>;
export const BidContractRevisionDocument = gql`
    query BidContractRevision($bidContractRevisionId: ID!) {
  bidContractRevision(id: $bidContractRevisionId) {
    ...BidContractRevision
  }
}
    ${BidContractRevisionFragmentDoc}`;

/**
 * __useBidContractRevisionQuery__
 *
 * To run a query within a React component, call `useBidContractRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractRevisionQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *   },
 * });
 */
export function useBidContractRevisionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractRevisionQuery, BidContractRevisionQueryVariables> & ({ variables: BidContractRevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractRevisionQuery, BidContractRevisionQueryVariables>(BidContractRevisionDocument, options);
      }
export function useBidContractRevisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractRevisionQuery, BidContractRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractRevisionQuery, BidContractRevisionQueryVariables>(BidContractRevisionDocument, options);
        }
// @ts-ignore
export function useBidContractRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidContractRevisionQuery, BidContractRevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractRevisionQuery, BidContractRevisionQueryVariables>;
export function useBidContractRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractRevisionQuery, BidContractRevisionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidContractRevisionQuery | undefined, BidContractRevisionQueryVariables>;
export function useBidContractRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractRevisionQuery, BidContractRevisionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractRevisionQuery, BidContractRevisionQueryVariables>(BidContractRevisionDocument, options);
        }
export type BidContractRevisionQueryHookResult = ReturnType<typeof useBidContractRevisionQuery>;
export type BidContractRevisionLazyQueryHookResult = ReturnType<typeof useBidContractRevisionLazyQuery>;
export type BidContractRevisionSuspenseQueryHookResult = ReturnType<typeof useBidContractRevisionSuspenseQuery>;
export type BidContractRevisionQueryResult = ApolloReactCommon.QueryResult<BidContractRevisionQuery, BidContractRevisionQueryVariables>;
export const SaveBidContractRevisionDocument = gql`
    mutation SaveBidContractRevision($input: SaveBidContractRevisionInput!) {
  saveBidContractRevision(input: $input) {
    bidContractRevision {
      ...BidContractRevision
    }
  }
}
    ${BidContractRevisionFragmentDoc}`;

/**
 * __useSaveBidContractRevisionMutation__
 *
 * To run a mutation, you first call `useSaveBidContractRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidContractRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidContractRevisionMutation, { data, loading, error }] = useSaveBidContractRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBidContractRevisionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidContractRevisionMutation, SaveBidContractRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidContractRevisionMutation, SaveBidContractRevisionMutationVariables>(SaveBidContractRevisionDocument, options);
      }
export type SaveBidContractRevisionMutationHookResult = ReturnType<typeof useSaveBidContractRevisionMutation>;
export type SaveBidContractRevisionMutationResult = ApolloReactCommon.MutationResult<SaveBidContractRevisionMutation>;
export const InternallySignBidContractRevisionDocument = gql`
    mutation InternallySignBidContractRevision($input: InternallySignBidContractRevisionInput!) {
  internallySignBidContractRevision(input: $input) {
    ...BidContractRevision
  }
}
    ${BidContractRevisionFragmentDoc}`;

/**
 * __useInternallySignBidContractRevisionMutation__
 *
 * To run a mutation, you first call `useInternallySignBidContractRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternallySignBidContractRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internallySignBidContractRevisionMutation, { data, loading, error }] = useInternallySignBidContractRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternallySignBidContractRevisionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InternallySignBidContractRevisionMutation, InternallySignBidContractRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InternallySignBidContractRevisionMutation, InternallySignBidContractRevisionMutationVariables>(InternallySignBidContractRevisionDocument, options);
      }
export type InternallySignBidContractRevisionMutationHookResult = ReturnType<typeof useInternallySignBidContractRevisionMutation>;
export type InternallySignBidContractRevisionMutationResult = ApolloReactCommon.MutationResult<InternallySignBidContractRevisionMutation>;
export const DeleteBidContractRevisionDocument = gql`
    mutation DeleteBidContractRevision($input: DeleteBidContractRevisionInput!) {
  deleteBidContractRevision(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useDeleteBidContractRevisionMutation__
 *
 * To run a mutation, you first call `useDeleteBidContractRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBidContractRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBidContractRevisionMutation, { data, loading, error }] = useDeleteBidContractRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBidContractRevisionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBidContractRevisionMutation, DeleteBidContractRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBidContractRevisionMutation, DeleteBidContractRevisionMutationVariables>(DeleteBidContractRevisionDocument, options);
      }
export type DeleteBidContractRevisionMutationHookResult = ReturnType<typeof useDeleteBidContractRevisionMutation>;
export type DeleteBidContractRevisionMutationResult = ApolloReactCommon.MutationResult<DeleteBidContractRevisionMutation>;